import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  savedDrugs: {},
  savedCoupons: {},
  couponData: {},
  savedLinkClicked: false,
  savedDrugClicked: false,
  isFetchDrug: false
};

const userDrugSlice = createSlice({
  name: 'userDrugs',
  initialState: initialState,
  reducers: {
    fetchSavedDrugs(state, action) {
      state.savedDrugs = action.payload.savedDrugs;
      state.isFetchDrug = false;
    },
    fetchSavedCoupons(state, action) {
      state.savedCoupons = action.payload.savedCoupons;
    },
    setCouponData(state, action) {
      state.couponData = action.payload.coupon;
    },
    setSavedLinkClick(state, action) {
      state.savedLinkClicked = action.payload.savedLinkClicked;
    },
    setSavedDrugClick(state, action) {
      state.savedDrugClicked = action.payload.savedDrugClicked;
    },
    setIsFetchDrug(state, action) {
      state.isFetchDrug = action.payload.isFetchDrug;
    }
  }
});

export const userDrugActions = userDrugSlice.actions;

export default userDrugSlice;
